export default __webpack_public_path__ + "static/media/d20-logo-white.2e08fb5a.png";